<template>
  <div>
    <center>
      <v-img height="100%" :src="require('@/assets/Icon/HRM.jpg')"></v-img>
      <v-container fluid>
        <v-overlay :value="dataReady">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row dense>
          <v-col style="padding-right: 8px; padding-left: 8px">
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="require('@/assets/Icon/Back.jpg')"
                max-height="30"
                max-width="100"
                :src="require('@/assets/Icon/Back.jpg')"
              ></v-img>
            </v-card>
            <v-card-text>
              <v-card class="mx-auto ma-5" color="#1B447C" dark max-width="400">
                <span class="text-h6 font-weight-light">คำร้องขอพิเศษ</span>
              </v-card>
              <v-row>
                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/menu_9.png')"
                    @click="GoLeavePrivilege()"
                  ></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/menu_doc.png')"
                    @click="GoDoc()"
                  ></v-img>
                </v-col>
                <!-- <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/menuOT.png')"
                    @click="GoMenuOT()"
                  ></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/adjustIMG.png')"
                    @click="GoAdjust()"
                  ></v-img>
                </v-col> -->

                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/welfare_14.png')"
                    @click="GoQues()"
                  ></v-img>
                </v-col>

                <!-- <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/welfare_14.png')"
                  ></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/welfare_13.png')"
                  ></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/welfare_10.png')"
                  ></v-img>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-img
                    height="100%"
                    :src="require('@/assets/iconMenu/welfare_11.png')"
                  ></v-img>
                </v-col> -->
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
// import axios from 'axios'
export default {
  components: {},
  name: 'Event',
  data () {
    return {
      profile: [],
      dataReady: true,
      imageHeadHRM: '',
      imageUrlBack: '',
      imageUrlActivity: '',
      imageUrlPersonalInfo: '',
      imageUrlFamilyInfo: '',
      imageUrlAddressInfo: '',
      imageUrlComingSoon: ''
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    // this.profile.empImageUrl = this.profile.empImageUrl
    this.dataReady = false
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    GoLeavePrivilege () {
      this.$router.push('/liff/LeavePrivilege')
    },
    GoDoc () {
      this.$router.push('/liff/RequestDoc')
    },
    GoQues () {
      this.$router.push('/Liff/QuestionnaireTrain')
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/HomeSpecialRequest.vue